import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({

    completionInfoContainer: {
        width: "100%",
        justifyContent: "center",
        fontSize: "100%"
    },

    completionStatusIcon:{
        
        color:"#3f51b5",
        marginLeft: "38%",
        marginBottom: "5%"
        
    },

    completionStatusText: {
        width:"100%",
        marginBottom: "5%"
    }
    

}));

export { useStyles };